import { getChildEntities } from 'app/infrastructure/store/query';
import {
  getCaseData,
  getEntityContext
} from 'app/infrastructure/ui/renderer/resolvers';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { Entity, StoreField } from 'app/types-shared';

export const getEvaluations = (checkListItems: Entity[]) => {
  const checkListItemsFlat = columnName[tableName.checklist].checkListEvaluationFlat;
  return checkListItems
    .map(r => r[checkListItemsFlat])
    .map(r => r && r[0]) // select first
    .filter(r => !!r); // remove undefined
};

export const getEvaluationGroupDetails = (evaluations: StoreField[]) => {

  const evaluationsGroupedByValue = !!evaluations.length && evaluations.reduce((aggr, curr) => {
    aggr[curr.value] = aggr[curr.value] || [];
    aggr[curr.value].push(curr);
    return aggr;
  }, {});

  const evaluationValueGroups = Object.keys(evaluationsGroupedByValue)
    .map(e => evaluationsGroupedByValue[e]); //now convert the grouped objects to array

  return evaluationValueGroups.map(group => ({
    key: group[0].value,
    value: group.length,
    tooltip: group[0].description,
    backgroundColor: group[0].backgroundColor
  })); //set the result object having desired properties
};

export const checklistValues = (caseState, uiEngineProps) => {
  const caseData = getCaseData(caseState, uiEngineProps);
  const entityContext = getEntityContext(caseState, uiEngineProps);

  const transPath = entityContext.path.slice(0, 1);

  const allChecklistEvaluations = getChildEntities(
    caseData,
    transPath,
    tableName.checklistEvaluation
  );
  const evaluations = getEvaluations(allChecklistEvaluations);

  const result = getEvaluationGroupDetails(evaluations);

  return {
    checklistEvaluations: result,
    numberOfChecklistItems: !!result?.length ? allChecklistEvaluations?.length : 0
  };
};

export interface ChecklistValuesShape {
  numberOfChecklistItems: number;
  checklistEvaluations: any;
}
